import { driver, type DriveStep } from 'driver.js';
import 'driver.js/dist/driver.css';
import type { messages as MSG } from '@/lib/i18n.messages';
import { LG_MEDIA_QUERY } from '@/hooks/useMediaQuery';

type TKey = keyof typeof MSG;

export const NEUNEU_TOUR_START_EVENT = 'nm-neuneu-tour-start';
export const NEUNEU_TOUR_END_EVENT = 'nm-neuneu-tour-end';

function isMobileNav(): boolean {
  return !window.matchMedia(LG_MEDIA_QUERY).matches;
}

function step(element: string, title: string, description: string): DriveStep {
  return { element, popover: { title, description, side: 'right', align: 'start' } };
}

export function startNeuNeuTour(t: (key: TKey) => string) {
  const steps: DriveStep[] = [
    step('[data-tour="nav-dashboard"]',  t('neuneu.tour.dashboard.title'),  t('neuneu.tour.dashboard.desc')),
    step('[data-tour="nav-toolkits"]',   t('neuneu.tour.toolkits.title'),   t('neuneu.tour.toolkits.desc')),
    step('[data-tour="nav-documents"]',  t('neuneu.tour.documents.title'),  t('neuneu.tour.documents.desc')),
    step('[data-tour="nav-support"]',    t('neuneu.tour.support.title'),    t('neuneu.tour.support.desc')),
    step('[data-tour="nav-settings"]',   t('neuneu.tour.settings.title'),   t('neuneu.tour.settings.desc')),
    step('[data-tour="nav-help"]',       t('neuneu.tour.help.title'),       t('neuneu.tour.help.desc')),
  ];

  const endTour = () => {
    window.dispatchEvent(new CustomEvent(NEUNEU_TOUR_END_EVENT));
  };

  const d = driver({
    showProgress: true,
    animate: true,
    overlayOpacity: 0.55,
    stagePadding: 8,
    stageRadius: 8,
    nextBtnText: t('neuneu.tour.next'),
    prevBtnText: t('neuneu.tour.prev'),
    doneBtnText: t('neuneu.tour.done'),
    steps,
    onDestroyed: endTour,
  });

  if (isMobileNav()) {
    window.dispatchEvent(new CustomEvent(NEUNEU_TOUR_START_EVENT));
    // Wait for drawer slide-in before highlighting nav items
    window.setTimeout(() => d.drive(), 320);
    return;
  }

  d.drive();
}
